// Datetime helpers. See server.py::_dt_iso for the mirroring backend logic.
//
// The API SHOULD return ISO strings with a UTC offset. Historically a few
// rows leaked out as bare naive strings ('2026-08-25T17:00:00' — read by JS
// as LOCAL time) or malformed '+00:00Z'. These helpers keep the UI honest
// so display bugs never re-surface if the DB has crufty data.

function normalizeIso(v) {
  if (v == null) return null;
  let s = String(v).replace('+00:00Z', '+00:00').replace('+0000Z', '+00:00');
  // Bare ISO without any tz marker → treat as UTC.
  const tail = s.slice(10);
  if (s.includes('T') && !s.endsWith('Z') && !/[+-]\d{2}:?\d{2}$/.test(tail)) {
    s = s + 'Z';
  }
  return s;
}

export function parseServerDate(v) {
  const s = normalizeIso(v);
  if (!s) return null;
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
}

// Format a server-provided date in the given IANA timezone.
// Falls back to the browser's local zone when tz is falsy.
// Always includes the short zone name so misreadings are impossible.
export function formatInTz(v, tz, opts = {}) {
  const d = parseServerDate(v);
  if (!d) return '';
  return d.toLocaleString([], {
    month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit',
    timeZone: tz || undefined,
    timeZoneName: 'short',
    ...opts,
  });
}
